import(/* webpackMode: "eager" */ "/runner/_work/hotline/hotline/frontend/src/app/layout.tsx");
